import { Flex, ListItem, Text, List, Box, Badge, Spinner, Button } from "@chakra-ui/react";
import { FC, Fragment } from "react";
import { Card } from "../..";
import { ITr069Device } from "../../../../hooks/useTr069List";
import { formatClock, timestampToDateString } from "../../../utils";
import { useTr069Details } from "../../../../hooks/useTr069Details";
import { useNavigate } from "react-router-dom";
import { useTr069AcsData } from "../../../../hooks/useTr069AcsData";

interface Tr069DeviceProps {
    id: string;
}

const mockData = {
    profileData: { name: "HALNY 1G" },
    serialNumber: "SERIAL010101",
    wifi: [{
        wifi_essid: "wifi lala",
        wifi_password: "haslo"
    }],
    services: { internet: { active: 1 } },
    creationDate: Math.floor(Date.now() / 1000),
};

const Tr069Device: FC<Tr069DeviceProps> = ({ id }) => {
    const { data, isLoading } = useTr069Details(id);
    const { acsData } = useTr069AcsData(id?.toString() || "");
    const { lastSeen, status } = acsData;
    // const data = mockData;
    // const isLoading = false;
    const navigate = useNavigate()

    // console.log('Tr069Device', data,);


    if (isLoading || !data) {
        return (
            <Box
                bg="gray.100"
                borderRadius="md"
                p={4}
                mb={4}
                mt={4}
                width="100%"
            >
                <Spinner size="lg" />
            </Box>
        );
    }
    return (
        <Button
            bg="gray.100"
            borderRadius="md"
            p={4}
            mb={4}
            mt={4}
            width="100%"
            minW="220px"
            minH="200px"
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            onClick={() => {
                navigate(`tr069/${id}`);
            }}
        >
            <Text fontWeight="bold">{data.modelName}</Text>
            <Text fontWeight="medium" fontSize="sm">S/N: {data.serialNumber}</Text>

            <Flex mt={2} color="gray.700" flexDir={'column'} alignItems={'flex-start'}>
                {/* <Text>{data.wifi.length ? data.wifi[0]?.wifi_essid : 'Brak nazwy'}</Text> */}
                <Text fontWeight="semibold">SSID: {data?.wifi?.[0]?.wifi_essid || 'Brak nazwy'}</Text>
                <Text fontWeight="semibold">Hasło: {data?.wifi?.[0]?.wifi_password || 'Brak hasła'}</Text>
            </Flex>

            <Flex width="100%" justify="center" mt={4}>
                <Badge
                    fontSize="md"
                    px={5}
                    py={2}
                    borderRadius="xl"
                    bg={status ? (status === 1 ? "lime" : status === 2 ? 'yellow' : 'red') : 'red'}
                    color="white"
                >
                    {status ? (status === 1 ? 'ONLINE' : status === 2 ? "NIEZNANY" : 'OFFLINE') : ''}
                </Badge>
            </Flex>

            <Text fontSize="xs" textAlign="center" color="gray.500" mt={4}>
                {/* {data.creationDate ? `Odczytano ${timestampToDateString(Number(data.creationDate) * 1000) + ' ' + formatClock(Number(data.creationDate) * 1000)}` : 'Brak daty'} */}
                {lastSeen ? `Odczytano ${timestampToDateString(Number(lastSeen) * 1000) + ' ' + formatClock(Number(lastSeen) * 1000)}` : 'Brak daty'}

            </Text>
        </Button>
    )
}

export interface ITr069DevicesCard {
    tr069Devices: ITr069Device[];
}


export const Tr069DevicesCard: FC<ITr069DevicesCard> = ({ tr069Devices }) => {

    return (
        <Card title="Internetowe" titleStyle={{ marginLeft: '5px' }} >
            <Flex overflowX="auto" gap={4} px={2}>
                {tr069Devices.length
                    ? tr069Devices.map(({ id }) => (
                        <Box key={id} minW="240px" flex="0 0 auto" m={"3px 5px"}>
                            <Tr069Device id={id.toString()} />
                        </Box>
                    ))
                    : null}
            </Flex>
        </Card>
    );
};
